<template>
  <div>
    <XVactionbar>
      <template slot="actionbuttons">
        <button type="button" id="btnOk" class="btn btn-primary btn-xs" @click="submit()">
          <font-awesome-icon :icon="['far', 'check']" />
          {{ translation(12980) }}
        </button>
        <button
          v-if="personalData.buttonStandaardTekstenVisible"
          type="button"
          id="btnStdTexts"
          class="btn btn-default btn-xs"
          @click="goToStdTexts()"
        >
          <font-awesome-icon icon="align-left" />
          {{ translation(3178) }}
        </button>
      </template>
    </XVactionbar>

    <div id="pnlTitleBar" class="margin20">
      <span id="lblTitel" class="titel">{{ translation(13) }}</span>
    </div>
    <div class="row">
      <div class="col-md-12">
        <p>
          <span id="lblBeschrijving" v-html="translation(80)"></span>
        </p>
      </div>
    </div>

    <div id="pnlPersonalData">
      <div class="row margin20">
        <div class="col-md-12">
          <fieldset>
            <!-- Name -->
            <template v-if="personalData.allowProfToViewName">
              <XVbootstraprow
                :label="translation(81)"
                :haserror="errors.has('name')"
                :errormessage="errors.first('name')"
                :required="true"
                class="margin20"
              >
                <XVinput
                  id="name"
                  name="name"
                  v-model="personalData.name"
                  v-validate="'required'"
                  :data-vv-as="translation(81)"
                  :disabled="!personalData.allowProfToChangeName"
                ></XVinput>
              </XVbootstraprow>
            </template>

            <!-- Email -->
            <template v-if="personalData.allowProfToViewEmail">
              <XVbootstraprow
                :label="translation(26)"
                :haserror="errors.has('email')"
                :errormessage="errors.first('email')"
                :required="true"
              >
                <XVinput
                  id="email"
                  name="email"
                  v-model="personalData.email"
                  v-validate="{ XVMultipleEmail: true, required: true, max: 100 }"
                  data-vv-validate-on="blur"
                  :data-vv-as="translation(26)"
                  :disabled="!personalData.allowProfToChangeEmail"
                ></XVinput>
              </XVbootstraprow>
            </template>

            <!-- Username -->
            <template v-if="personalData.allowProfToViewUsername">
              <XVbootstraprow
                :label="translation(2302)"
                :haserror="errors.has('username')"
                :errormessage="errors.first('username')"
                :required="true"
              >
                <XVinput
                  id="username"
                  name="username"
                  v-model="personalData.username"
                  v-validate="SchemaCheckUsername()"
                  data-vv-validate-on="blur"
                  :data-vv-as="translation(2302)"
                  :disabled="!personalData.allowProfToChangeUsername"
                ></XVinput>
              </XVbootstraprow>
            </template>

            <!-- Password -->
            <template>
              <XVbootstraprow :label="translation(2303)">
                <a
                  v-if="personalData.allowProfToChangePassword"
                  id="changePassword"
                  href="#"
                  @click="goToChangePassword()"
                  >{{ translation(60) }}</a
                >
                <p v-if="!personalData.allowProfToChangePassword">{{ translation(1052) }}</p>
              </XVbootstraprow>
            </template>

            <!-- Pincode -->
            <XVbootstraprow
              v-if="personalData.usePincodeAllowed"
              :label="translation(8971)"
              :helptext="translation(9080)"
            >
              <a id="changePincode" href="#" @click="goToChangePincode()">{{ translation(8973) }}</a>
            </XVbootstraprow>

            <!-- MFA -->
            <XVbootstraprow v-if="personalData.hasPassword"
              id="lblPreferredMfaVerification"
              :label="translation(20279)"
              :helptext="translation(20280)"
              :required="true"
              :haserror="errors.has('PreferredMfaVerification')"
              :errormessage="errors.first('PreferredMfaVerification')"
            >

            <XVradiobuttonlist
                id="PreferredMfaVerification"
                name="PreferredMfaVerification"
                :datalist="PreferredMfaVerificationOptions"
                v-model="personalData.preferredMfaVerification"
                @input="setPreferredMfaVerification"
                :disabled="!personalData.mfaEditable"
              ></XVradiobuttonlist>
            </XVbootstraprow>

            <!-- Message to my email -->
            <XVbootstraprow 
              id="lblMailNormalFrequence"
              :label="translation(1436)"
              :helptext="translation(1434)"
              :required="true"
              :haserror="errors.has('mailNormalFrequence')"
              :errormessage="errors.first('mailNormalFrequence')"
            >
              <XVdropdown
                id="mailNormalFrequence"
                name="mailNormalFrequence"
                :datalist="mailNormalFrequenceOptions"
                v-model="personalData.mailNormalFrequence"
                @input="setMailNormalFrequence"
                v-validate="'required'"
                :data-vv-as="translation(1436)"
              ></XVdropdown>
            </XVbootstraprow>

            <!-- Tr OutOfOffice incl metaheader -->
            <template v-if="personalData.outOfOfficeNotificationAllowed">
              <XVbootstraprow class="margin20 metaHeader">
                <span class="pull-left">
                  <XVhelpcontrol :helptext="translation(11925)"></XVhelpcontrol>
                </span>
                <span>{{ translation(11924) }}</span>
              </XVbootstraprow>

              <div id="trHeaderOufOfOffice">
                <XVbootstraprow :label="translation(11916)" :helptext="translation(11917)">
                  <XVradiobuttonlist
                    id="sendOutOfOfficeNotification"
                    :datalist="outOfOfficeSelectionOptions"
                    v-model="personalData.sendOutOfOfficeNotification"
                    @input="setSendOutOfOfficeNotification"
                  ></XVradiobuttonlist>
                </XVbootstraprow>
              </div>

              <!-- outOfOfficeSettings -->
              <div id="outOfOfficeSettings" v-if="personalData.sendOutOfOfficeNotification" class="margin20">
                <!-- StartDate -->
                <div class="row">
                  <div class="col-md-4">
                    <span class="pull-right">
                      <XVhelpcontrol :helptext="translation(11919)"></XVhelpcontrol>
                    </span>
                    <label>
                      <span>{{ translation(11918) }}</span>
                      <span>
                        <font-awesome-icon :icon="['fal', 'asterisk']" size="xs" />
                      </span>
                    </label>
                  </div>
                  <div
                    class="col-md-8 form-group has-feedback"
                    v-bind:class="{
                      'form-group--error':
                        errors.has('startDate') ||
                        isAfter(personalData.outOfOfficeSettings.startDate, personalData.outOfOfficeSettings.endDate),
                    }"
                  >
                    <XVdate
                      id="startDate"
                      key="startDate"
                      name="startDate"
                      :data-vv-as="translation(11918)"
                      v-validate="{ XVDateDefault: true, required: true }"
                      v-model="personalData.outOfOfficeSettings.startDate"
                      @input="$validator.validate()"
                    ></XVdate>
                    <span class="form-group__message">{{ errors.first('startDate') }}</span>
                    <span
                      class="form-group__message"
                      v-if="
                        isAfter(personalData.outOfOfficeSettings.startDate, personalData.outOfOfficeSettings.endDate)
                      "
                      >{{ translation(11918) }} {{ translation(15270) }} {{ translation(11920) }}</span
                    >
                  </div>
                </div>

                <!-- EndDate -->
                <div class="row">
                  <div class="col-md-4">
                    <span class="pull-right">
                      <XVhelpcontrol :helptext="translation(11921)"></XVhelpcontrol>
                    </span>
                    <label>
                      <span>{{ translation(11920) }}</span>
                      <span>
                        <font-awesome-icon :icon="['fal', 'asterisk']" size="xs" />
                      </span>
                    </label>
                  </div>
                  <div
                    class="col-md-8 form-group has-feedback"
                    v-bind:class="{
                      'form-group--error':
                        errors.has('endDate') ||
                        isBefore(personalData.outOfOfficeSettings.endDate, personalData.outOfOfficeSettings.startDate),
                    }"
                  >
                    <XVdate
                      id="endDate"
                      key="endDate"
                      name="endDate"
                      :data-vv-as="translation(11920)"
                      v-validate="{ XVDateDefault: true, required: true }"
                      v-model="personalData.outOfOfficeSettings.endDate"
                      @input="$validator.validate()"
                    ></XVdate>
                    <span class="form-group__message">{{ errors.first('endDate') }}</span>
                    <span
                      class="form-group__message"
                      v-if="
                        isBefore(personalData.outOfOfficeSettings.endDate, personalData.outOfOfficeSettings.startDate)
                      "
                      >{{ translation(11920) }} {{ translation(14377) }} {{ translation(11918) }}</span
                    >
                  </div>
                </div>

                <!-- Message -->
                <XVbootstraprow
                  :label="translation(11922)"
                  :helptext="translation(11923)"
                  :required="true"
                  :haserror="errors.has('message')"
                  :errormessage="errors.first('message')"
                >
                  <XVtextarea
                    id="message"
                    name="message"
                    v-model="personalData.outOfOfficeSettings.message"
                    v-validate="'required'"
                    :data-vv-as="translation(11922)"
                  ></XVtextarea>
                  <span class="form-group__message">{{ errors.first('message') }}</span>
                </XVbootstraprow>
              </div>
            </template>
          </fieldset>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { FAMixin } from 'pevueglobal'
import { isBefore, isAfter } from 'date-fns'
export default {
  mixins: [FAMixin],
  mounted() {
    this.getTexten()
    this.initPersonalData()
  },
  computed: {
    ...mapGetters('Spe010Persoonsgegevens', ['personalData', 'currentUser']),

    mailNormalFrequenceOptions() {
      return [
        { value: '0', labelText: this.translation(1438), helpText: this.translation(1438) },
        { value: '1', labelText: this.translation(1439), helpText: this.translation(1439) },
        { value: '2', labelText: this.translation(1440), helpText: this.translation(1440) },
        { value: '3', labelText: this.translation(1441), helpText: this.translation(1441) },
      ]
    },

   PreferredMfaVerificationOptions() {
      return [
        { value: '0', labelText: this.translation(20278), helpText: this.translation(20278) },
        { value: '1', labelText: this.translation(20277), helpText: this.translation(20277) },
      ]
    },

    outOfOfficeSelectionOptions() {
      return [
        { value: false, labelText: this.translation(11914), helpText: this.translation(11914) },
        { value: true, labelText: this.translation(11915), helpText: this.translation(11915) },
      ]
    },

    startDateValidation() {
      return isBefore(this.personalData.outOfOfficeSettings.startDate, this.personalData.outOfOfficeSettings.endDate)
    },
    endDateValidation() {
      return isAfter(this.personalData.outOfOfficeSettings.endDate, this.personalData.outOfOfficeSettings.startDate)
    },
  },
  methods: {
    isBefore,
    isAfter,
    ...mapActions('Spe010Persoonsgegevens', ['getTexten','initPersonalData', 'submitPersonalData']),
    ...mapMutations('Spe010Persoonsgegevens', ['setSendOutOfOfficeNotification', 'setMailNormalFrequence', 'setPreferredMfaVerification']),

    goToStdTexts() {
      window.location = '/beheer/SPE011_BH_UserDefaultText.aspx'
    },

    goToChangePassword() {
      window.location = '/beheer/SPE329_BH_WachtwoordWijzigen.aspx'
    },

    goToChangePincode() {
      window.location = '/beheer/SPE649_BH_ChangePinCode.aspx'
    },

    SchemaCheckUsername() {
      return {
        required: true,
        regex: /^[\S]*$/,
        customServerValidate: {
          validatorApiRoute: 'public/PEapi_CheckUsernameIsUnique/',
          parameters: {
            SES_PersonID: this.personalData.id,
            SES_rol: this.currentUser.rol,
          },
        },
      }
    },

    submit() {
      this.$validator.validate().then((result) => {
        if (
          result &&
          (!this.personalData.sendOutOfOfficeNotification || (this.startDateValidation && this.endDateValidation))
        ) {
          this.submitPersonalData()
        }
      })
    },
  },
}
</script>
